import { render, staticRenderFns } from "./BaseDropdownActions.vue?vue&type=template&id=6f6ed7f8&scoped=true"
import script from "./BaseDropdownActions.vue?vue&type=script&lang=js"
export * from "./BaseDropdownActions.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownActions.vue?vue&type=style&index=0&id=6f6ed7f8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ed7f8",
  null
  
)

export default component.exports